import React, { useContext, useEffect } from 'react';
import YouTube from 'react-youtube';
import { MusicPlayerContext } from './MusicPlayerContext';

const GlobalMusicPlayer = () => {
  const {
    playlistTracks,
    currentTrackIndex,
    isPlaying,
    setIsPlaying,
    isShuffling,
    setCurrentTrackIndex,
    playerRef,
  } = useContext(MusicPlayerContext);

  const videoId = playlistTracks[currentTrackIndex]?.snippet?.resourceId?.videoId;

  const playNextTrack = () => {
    if (!playlistTracks.length) return;
    const newIndex = isShuffling
      ? Math.floor(Math.random() * playlistTracks.length)
      : (currentTrackIndex + 1) % playlistTracks.length;
    setCurrentTrackIndex(newIndex);
    setIsPlaying(true);
  };

  const onPlayerReady = (event) => {
    playerRef.current = event.target;
    if (isPlaying) {
      playerRef.current.playVideo();
    }
  };

  const onPlayerStateChange = (event) => {
    if (event.data === window.YT.PlayerState.ENDED) {
      playNextTrack();
    }
  };

  // When the video changes the old player is destroyed before the new one is
  // ready.  Clear the ref immediately so the playback effect below never calls
  // methods on a stale, invalid player instance.  onPlayerReady will re-set
  // the ref and start the new track once the player is initialised.
  useEffect(() => {
    playerRef.current = null;
  }, [videoId, playerRef]);

  // Only respond to explicit play/pause toggles from the user.
  // Track transitions are handled by onPlayerReady + autoplay:1 above.
  useEffect(() => {
    if (!playerRef.current) return;
    try {
      if (isPlaying) {
        playerRef.current.playVideo();
      } else {
        playerRef.current.pauseVideo();
      }
    } catch {
      // Player is mid-transition; onPlayerReady will resume when ready.
    }
  }, [isPlaying, playerRef]);

  if (!videoId) return null;

  return (
    <div style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}>
      <YouTube
        videoId={videoId}
        opts={{
          height: '0',
          width: '0',
          playerVars: { autoplay: 1 },
        }}
        onReady={onPlayerReady}
        onStateChange={onPlayerStateChange}
      />
    </div>
  );
};

export default GlobalMusicPlayer;
